var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.134,
    height: 51.551,
    viewBox: "0 0 81.134 51.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_144",
    transform: "translate(-17.195 -37.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_280",
    d: "M62.2,46.6l6.356-.9-7.185,7.323a.766.766,0,0,0-.138,1.036.958.958,0,0,0,.829.484h.207l8.981-1.52a.86.86,0,0,0,.76-.967v-.069a.926.926,0,0,0-1.036-.76h0L64.76,52.268l7.047-7.254a1.362,1.362,0,0,0,.207-1.036.981.981,0,0,0-.967-.484l-8.981,1.382a1.041,1.041,0,0,0-.829,1.036A.723.723,0,0,0,62.2,46.6Z",
    transform: "translate(-13.571 -1.948)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2107",
    d: "M39.6,40.372l6.356-.9-7.185,7.254a.766.766,0,0,0-.138,1.036.958.958,0,0,0,.829.484h.207l8.981-1.52a.86.86,0,0,0,.76-.967v-.069a.926.926,0,0,0-1.036-.76h0L42.16,45.968l7.047-7.254a1.362,1.362,0,0,0,.207-1.036.981.981,0,0,0-.967-.484l-8.981,1.382a1.041,1.041,0,0,0-.829,1.036A.825.825,0,0,0,39.6,40.372Z",
    transform: "translate(-6.585)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2108",
    d: "M18.3,46.6l6.356-.9-7.185,7.323a.766.766,0,0,0-.138,1.036.958.958,0,0,0,.829.484h.207l8.981-1.52a.86.86,0,0,0,.76-.967v-.069a.926.926,0,0,0-1.036-.76h0L20.86,52.268l7.047-7.254a1.362,1.362,0,0,0,.207-1.036.981.981,0,0,0-.967-.484l-8.981,1.382a1.041,1.041,0,0,0-.829,1.036A.746.746,0,0,0,18.3,46.6Z",
    transform: "translate(0 -1.948)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_281",
    d: "M80.7,52.427l4.629-.691L79.875,57.4a.766.766,0,0,0-.138,1.036.958.958,0,0,0,.829.484h.207l7.392-1.244a.86.86,0,0,0,.76-.967v-.069a.926.926,0,0,0-1.036-.76h0l-4.629.829,5.389-5.6a1.362,1.362,0,0,0,.207-1.036.981.981,0,0,0-.967-.484L80.428,50.7a1.041,1.041,0,0,0-.829,1.036.926.926,0,0,0,1.036.76c0-.069,0-.069.069-.069Z",
    transform: "translate(-19.29 -3.833)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_282",
    d: "M95.7,59.281,97.5,59,94.875,61.7a.766.766,0,0,0-.138,1.036.958.958,0,0,0,.829.484h.207l4.56-.829a.909.909,0,1,0-.276-1.8l-1.658.345,2.556-2.625a1.362,1.362,0,0,0,.207-1.036.981.981,0,0,0-.967-.484l-4.56.691a1.041,1.041,0,0,0-.829,1.036.784.784,0,0,0,.829.76Z",
    transform: "translate(-23.928 -6.059)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_283",
    d: "M101.763,75.776a5.819,5.819,0,0,0-1.865.553,9.341,9.341,0,0,1-2.349.76.982.982,0,0,1-.415-.138,10.778,10.778,0,0,1-2.763-2.833,12.1,12.1,0,0,0-10.639-5.872c-1.313,0-3.454-.069-6.01-.138-4.214-.069-9.534-.207-14.439-.207-7.116,0-11.606.276-13.541.691-4.076.967-5.941,3.247-8.014,5.6-.484.622-1.036,1.244-1.658,1.934a1.547,1.547,0,0,1-1.174.415,8.975,8.975,0,0,1-2.971-.76,4.706,4.706,0,0,0-1.934-.484,1.375,1.375,0,0,0-1.105.484,1.683,1.683,0,0,0-.138,1.52c.415,1.382,1.727,2.625,2.971,3.869.967.967,2.142,2.073,2.349,2.833l.069.276c3.109,11.4,8.221,13.886,12.021,13.886.345,0,.76.069,1.105.069a8.36,8.36,0,0,0,1.313-.069h.207a16.781,16.781,0,0,0,7.6-2.694c.415-.276.9-.622,1.382-.967,1.934-1.451,4.422-3.178,6.287-3.247h.069c1.52,0,3.662,1.451,5.527,2.694a22.167,22.167,0,0,0,2.625,1.589,20.705,20.705,0,0,0,8.7,2.487h.276c5.941,0,10.017-5.043,11.4-9.948a7.337,7.337,0,0,0,.276-1.313c.345-1.658.76-3.247,1.934-4.214a4.829,4.829,0,0,1,1.174-.9c1.589-1.244,3.109-2.418,3.04-4.56a1.154,1.154,0,0,0-1.036-1.382.522.522,0,0,1-.276.069Zm-2.9,4.214c-.345.276-.829.622-1.244.967-1.658,1.451-2.142,3.454-2.556,5.251a8.034,8.034,0,0,0-.276,1.244c-1.036,3.938-4.145,8.5-9.465,8.5h-.276a17.076,17.076,0,0,1-7.807-2.28,21.851,21.851,0,0,1-2.418-1.52c-2.142-1.451-4.491-2.971-6.632-2.971H67.98c-2.487.069-5.251,2.073-7.392,3.592-.484.276-.9.691-1.313.9a15.036,15.036,0,0,1-6.563,2.349h-1.52a4.248,4.248,0,0,0-.967.069c-3.04-.069-7.185-2.28-9.948-12.435l-.069-.276c-.345-1.313-1.589-2.487-2.9-3.8a16.356,16.356,0,0,1-1.865-1.934,13.055,13.055,0,0,0,3.592.9,3.316,3.316,0,0,0,2.694-1.105c.622-.691,1.174-1.382,1.727-2,1.934-2.28,3.454-4.076,6.909-4.905,1.727-.415,6.149-.622,13.057-.622,4.905,0,10.156.138,14.37.207,2.694.069,4.767.138,6.08.138a10.053,10.053,0,0,1,8.912,4.974A9.724,9.724,0,0,0,96.1,78.608a2.54,2.54,0,0,0,1.52.415,8.411,8.411,0,0,0,3.178-.9h.069A12.6,12.6,0,0,1,98.861,79.99Z",
    transform: "translate(-4.77 -9.497)",
    fill: "#31b2cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_284",
    d: "M66.263,100.945c-.76.345-1.52.691-2.142.967a1.021,1.021,0,0,0-.553,1.313,1.065,1.065,0,0,0,.9.622.518.518,0,0,0,.345-.069c.829-.345,1.589-.691,2.349-1.036a1.028,1.028,0,0,0,.415-1.382.95.95,0,0,0-1.313-.415Z",
    transform: "translate(-14.314 -19.674)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_285",
    d: "M114.725,80.407a9.789,9.789,0,0,1,.553,1.244.954.954,0,0,0,.9.691.518.518,0,0,0,.345-.069,1,1,0,0,0,.622-1.313,6.724,6.724,0,0,0-.76-1.589,3.1,3.1,0,0,0-.76-.9,1.026,1.026,0,0,0-1.451,1.451h0A4.508,4.508,0,0,1,114.725,80.407Z",
    transform: "translate(-29.891 -12.677)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_286",
    d: "M65.619,75.067a.944.944,0,0,0-.967-.967h0c-.9,0-1.8,0-2.487.069a.961.961,0,0,0-.967,1.036.944.944,0,0,0,.967.967h0c.691,0,1.52,0,2.487-.069A1,1,0,0,0,65.619,75.067Z",
    transform: "translate(-13.601 -11.413)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_287",
    d: "M72.867,76.034h2.487a.944.944,0,0,0,.967-.967h0a.89.89,0,0,0-.9-.967H72.867a.967.967,0,0,0,0,1.934Z",
    transform: "translate(-16.911 -11.413)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_288",
    d: "M47.136,88.059a.9.9,0,0,0,.9-.691,11.692,11.692,0,0,1,.9-2.142,1.02,1.02,0,0,0-1.8-.967h0a10.408,10.408,0,0,0-.967,2.418.969.969,0,0,0,.553,1.244h.069A.252.252,0,0,0,47.136,88.059Z",
    transform: "translate(-8.935 -14.387)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_289",
    d: "M48.949,94.906a.983.983,0,1,0-1.865.622h0a14.987,14.987,0,0,0,1.036,2.418,1.078,1.078,0,0,0,.9.484,1.281,1.281,0,0,0,.484-.138.875.875,0,0,0,.415-1.244.068.068,0,0,0-.069-.069A13.434,13.434,0,0,1,48.949,94.906Z",
    transform: "translate(-9.229 -17.642)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_290",
    d: "M54.9,77.394a.978.978,0,0,0-1.036-1.658,10.192,10.192,0,0,0-2.073,1.8.98.98,0,0,0,.069,1.382h0a1.228,1.228,0,0,0,.691.276,1.449,1.449,0,0,0,.76-.276A8.187,8.187,0,0,1,54.9,77.394Z",
    transform: "translate(-10.616 -11.874)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_291",
    d: "M56.584,103.09a3.475,3.475,0,0,1-1.865-.553,1.007,1.007,0,0,0-1.036,1.727,7.036,7.036,0,0,0,2.833.829.944.944,0,0,0,.967-.967.875.875,0,0,0-.9-1.036Z",
    transform: "translate(-11.129 -20.161)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_292",
    d: "M75.524,95.459a22.161,22.161,0,0,0-2.142,1.313.927.927,0,0,0-.345,1.313.068.068,0,0,0,.069.069,1.078,1.078,0,0,0,.9.484,1.3,1.3,0,0,0,.553-.138c.9-.484,1.52-.9,2.142-1.244a.875.875,0,0,0,.415-1.244.068.068,0,0,0-.069-.069A1.272,1.272,0,0,0,75.524,95.459Z",
    transform: "translate(-17.219 -17.988)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_293",
    d: "M115.715,98.512a1.072,1.072,0,0,0-1.451.207h0a11.71,11.71,0,0,1-1.52,1.658.923.923,0,0,0-.069,1.382h0a.822.822,0,0,0,.76.276.887.887,0,0,0,.691-.276,12.407,12.407,0,0,0,1.8-2A.8.8,0,0,0,115.715,98.512Z",
    transform: "translate(-29.431 -18.9)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_294",
    d: "M107.848,74.677c-.967-.276-1.934-.553-2.487-.691a.989.989,0,1,0-.415,1.934h0a13.986,13.986,0,0,1,2.28.622.415.415,0,0,0,.276.069.9.9,0,0,0,.9-.691.862.862,0,0,0-.484-1.174A.068.068,0,0,0,107.848,74.677Z",
    transform: "translate(-26.883 -11.369)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_295",
    d: "M106.177,102.737c-.553-.138-1.451-.276-2.349-.553a1.006,1.006,0,0,0-.553,1.934c.967.276,1.865.415,2.487.553h.207a.969.969,0,0,0,.967-.829A1,1,0,0,0,106.177,102.737Z",
    transform: "translate(-26.386 -20.084)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_296",
    d: "M118.395,88.2a1.006,1.006,0,0,0-.9,1.105h0c.069.76.138,1.451.138,2.142v.276a1,1,0,0,0,.967,1.036.944.944,0,0,0,.967-.967h0v-.276c0-.76-.069-1.52-.138-2.349a.944.944,0,0,0-.967-.967Z",
    transform: "translate(-31.005 -15.772)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_297",
    d: "M96.854,73.9H94.367a.967.967,0,0,0,0,1.934h2.487a.944.944,0,0,0,.967-.967.906.906,0,0,0-.967-.967Z",
    transform: "translate(-23.558 -11.351)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_298",
    d: "M86.054,73.9H83.567a.967.967,0,0,0,0,1.934h2.487a.944.944,0,0,0,.967-.967.906.906,0,0,0-.967-.967Z",
    transform: "translate(-20.219 -11.351)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_299",
    d: "M86.446,94.682c-.967-.345-1.8-.691-2.418-.9a1.006,1.006,0,0,0-.553,1.934c.553.207,1.313.415,2.211.829a.751.751,0,0,0,.345.069.984.984,0,0,0,.9-.622A.939.939,0,0,0,86.446,94.682Z",
    transform: "translate(-20.265 -17.488)",
    fill: "#6a8be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_300",
    d: "M96.343,99.17l-2.211-1.105a1.126,1.126,0,0,0-1.382.484,1.056,1.056,0,0,0,.484,1.382c.9.415,1.589.829,2.211,1.036a.982.982,0,0,0,.415.138.926.926,0,0,0,.9-.553A.992.992,0,0,0,96.343,99.17Z",
    transform: "translate(-23.323 -18.797)",
    fill: "#6a8be5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.07feec52efa3a7854f4adc4716b1e0f1.svg";
export { ForwardRef as ReactComponent };